module.exports = __webpack_public_path__ + "static/media/gw1.07dcadb8.webp";